import { createDocumentPage, getDocumentTextForType } from "./documentBaseUtils";

export function generatePrintTaximeterCalibrationHtml(config, data, user, breakNewPage = false) {
    const { getDocumentText } = getDocumentTextForType(data, config);
    return createDocumentPage({title: 'AUTORIZAÇÃO', documentText: getDocumentText('AFERICAO_TAXIMETRO'), config, data, user}, {compat: true, showUserName: true, breakNewPage: breakNewPage});
}
